module.exports = __webpack_public_path__ + "img/missionaries1_7-10-2021.a6ea3303.jpg";